<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button mode="md" defaultHref="/settings"></ion-back-button>
    </ion-buttons>
    <smr-stylist-picker
      [stylistID]="stylistID"
      [readOnly]="readOnlyStylistPicker"
      (onInit)="onStylistPickerInit($event)"
      (stylistSelect)="onStylistSelect($event)"
      cssClass="smr-stylist-picker-for-socialmediasettings">  
    </smr-stylist-picker>
  </ion-toolbar>
</ion-header>
<ion-content>
  <salonmonster-load-mask *ngIf='isLoading'></salonmonster-load-mask>

  <salonmonster-tap-retry 
    *ngIf="errorOccurredWhileLoadingStylistPicker || errorOccurredWhileLoadingStylistSocialMediaLinks" 
    (click)="onTapToReload()"></salonmonster-tap-retry>

  <ng-container *ngIf="!isLoading && !errorOccurredWhileLoadingStylistPicker && !errorOccurredWhileLoadingStylistSocialMediaLinks">

  <ion-row>
    <ion-col class="hidden-sm-down"></ion-col>
    <ion-col size="12" size-sm="12" size-md="8" size-lg="8" size-xl="8">
      <ion-item class="text-wrap" lines="none">
        Simply add your social media links below and they will be displayed at the bottom of your online booking page for your clients.
      </ion-item>


        <form [formGroup]='socialMediaSettingsForm'>

          <ion-item lines="none">
            <ion-label position="stacked"><ion-icon name='logo-facebook' item-left></ion-icon> Facebook</ion-label>
            <ion-input type="text" name='' formControlName="facebook" placeholder="eg. https://www.facebook.com/yourpage/" clearInput></ion-input>
          </ion-item>

          <ion-item [hidden]="facebookField.valid || (facebookField.pristine && !submitted)">
            <p *ngIf="facebookField.hasError('maxlength')">
              Facebook URL cannot exceed 100 characters.
            </p>
          </ion-item>

          <ion-item lines="none">
            <ion-label position="stacked"><ion-icon name='logo-twitter' item-left></ion-icon> Twitter</ion-label>
            <ion-input type="text" name='' formControlName="twitter" placeholder="eg. https://twitter.com/yourusername/" clearInput></ion-input>
          </ion-item>

          <ion-item [hidden]="twitterField.valid || (twitterField.pristine && !submitted)">
            <p *ngIf="facebookField.hasError('maxlength')">
              Twitter URL cannot exceed 100 characters.
            </p>
          </ion-item>

          <ion-item lines="none">
            <ion-label position="stacked"><ion-icon name='logo-facebook' item-left></ion-icon> Instagram</ion-label>
            <ion-input type="text" name='' formControlName="instagram" placeholder="eg. https://instagram.com/yourname/" clearInput></ion-input>
          </ion-item>

          <ion-item [hidden]="instagramField.valid || (instagramField.pristine && !submitted)">
            <p *ngIf="instagramField.hasError('maxlength')">
              Instagram URL cannot exceed 100 characters.
            </p>
          </ion-item>

          <ion-item lines="none">
            <ion-label position="stacked"><ion-icon name='logo-google' item-left></ion-icon> Google+</ion-label>
            <ion-input type="text" name='' formControlName="googleplus" placeholder="eg. http://plus.google.com/00214392863666662729" clearInput></ion-input>
          </ion-item>

          <ion-item [hidden]="googlePlusField.valid || (googlePlusField.pristine && !submitted)">
            <p *ngIf="googlePlusField.hasError('maxlength')">
              Google+ URL cannot exceed 100 characters.
            </p>
          </ion-item>

          <ion-item lines="none">
            <ion-label position="stacked"><ion-icon name='logo-pinterest' item-left></ion-icon> Pinterest</ion-label>
            <ion-input type="text" name='' formControlName="pinterest" placeholder="eg. https://www.pinterest.com/yoursalon/" clearInput></ion-input>
          </ion-item>

          <ion-item [hidden]="pinterestField.valid || (pinterestField.pristine && !submitted)">
            <p *ngIf="pinterestField.hasError('maxlength')">
              Pinterest URL cannot exceed 100 characters.
            </p>
          </ion-item>

          <ion-item lines="none">
            <ion-label position="stacked"><ion-icon name='logo-tumblr' item-left></ion-icon> Tumblr</ion-label>
            <ion-input type="text" name='' formControlName="tumblr" placeholder="eg. http://yoursalon.tumblr.com" clearInput></ion-input>
          </ion-item>

          <ion-item [hidden]="tumblrField.valid || (tumblrField.pristine && !submitted)">
            <p *ngIf="tumblrField.hasError('maxlength')">
              Tumblr URL cannot exceed 100 characters.
            </p>
          </ion-item>

          <ion-item lines="none">
            <ion-label position="stacked">Yelp</ion-label>
            <ion-input type="text" name='' formControlName="yelp" placeholder="eg. https://www.yelp.ca/biz/your-salon-name" clearInput></ion-input>
          </ion-item>

          <ion-item [hidden]="yelpField.valid || (yelpField.pristine && !submitted)">
            <p *ngIf="yelpField.hasError('maxlength')">
              Yelp URL cannot exceed 100 characters.
            </p>
          </ion-item>
     
        <br/>
        <ion-button 
          expand="block"
          class="hidden-sm-down"
          (click)="onSocialMediaLinksFormSave()">
          Save
        </ion-button>
      </form>
      </ion-col>
        <ion-col class="hidden-sm-down"></ion-col>
    </ion-row>   
  <br /><br /><br /><br />
  </ng-container>

</ion-content>

<ion-footer class="ion-no-margin hidden-md-up"  *ngIf="!isLoading && !errorOccurredWhileLoadingStylistPicker && !errorOccurredWhileLoadingStylistSocialMediaLinks">
  <ion-toolbar class="ion-no-margin ion-no-padding">
      <ion-button
      class="ion-no-margin"
      
      expand="block"
      color="primary"
      fill="solid"
      (click)="onSocialMediaLinksFormSave()"
      [disabled]="isLoading">Save</ion-button>  
  </ion-toolbar>
</ion-footer>
